export default __webpack_public_path__ + "static/FiraMono-Regular-42fa25b081e5444269e2451ddda5c3ae.woff2";